export const CHECK = process.env.REACT_APP_CHECK || ''
export const API_URL = process.env.REACT_APP_API_URL || ''
